
import service from '@/service/chat_api'
import r4SettleApiList from "../service/basic/r4SettleApiList";
const myhost = myhostname

// 获取对账明细
export function queryAccountList(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4SettleApiList.getAccountList}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取结算单明细
export function queryAccountDetail(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4SettleApiList.getAccountDetail}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 批量确认
export function doAccountConfirm(params = {}) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${r4SettleApiList.accountConfirm}`, params).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 申诉
export function doAccountAppeal(params = {}) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${r4SettleApiList.accountAppeal}`, params).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 查看原单
export function doOriginalOrder(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4SettleApiList.originalOrder}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 判断供应商是否支持红蓝相抵
export function doRedBlueOffset(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4SettleApiList.getRedBlueOffset}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/models/r4SettleModel.js